import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "../../assets/styles/Gallery.css";

// import required modules
import { Zoom, Navigation, Pagination } from "swiper";

export default function Gallery() {
  return (
      <div id="gallery" className="gallery-wrapper">
        <Swiper
            style={{
            "--swiper-navigation-color": "#fff",
            "--swiper-pagination-color": "#fff",
            }}
            zoom={true}
            navigation={true}
            pagination={{
            clickable: true,
            }}
            modules={[Zoom, Navigation, Pagination]}
            className="mySwiper"
        >
            <div className="gallery-header">
                VIDEOS
            </div>
            <SwiperSlide>
            <div className="swiper-zoom-container">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/USnDvhNR-d8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            </SwiperSlide>
            <SwiperSlide>
            <div className="swiper-zoom-container">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/qzuBt5-4iTs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            </SwiperSlide>
            <SwiperSlide>
            <div className="swiper-zoom-container">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/jTvWmI2jAuE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            </SwiperSlide>
            <SwiperSlide>
            <div className="swiper-zoom-container">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/4ttMIqWH5n8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            </SwiperSlide>
        </Swiper>
    </div>
  );
}
